// @flow

import type {IntlShape} from 'react-intl';

const getTranslationIfAvailable = (intl: IntlShape, messageId: string): ?string => {
  try {
    const translation = intl.formatMessage({id: messageId});
    return !translation.includes(messageId) ? intl.formatMessage({id: messageId}) : null;
  } catch (error) {
    return null;
  }
};

export const buildReportTranslations = (intl: IntlShape): ?Object => {
  const translations = {};

  // Only add fields that have actual translations
  const transactionId = getTranslationIfAvailable(
    intl,
    'app.support.disputes.table.transaction-id'
  );
  if (transactionId) {
    translations.transaction_id = transactionId;
  }

  const transactionDate = getTranslationIfAvailable(
    intl,
    'app.support.disputes.table.transaction-date'
  );
  if (transactionDate) {
    translations.transaction_date = transactionDate;
  }

  const project = getTranslationIfAvailable(intl, 'app.support.disputes.table.project');
  if (project) {
    translations.project_id = project;
  }

  const paymentMethod = getTranslationIfAvailable(
    intl,
    'app.support.disputes.table.payment-method'
  );
  if (paymentMethod) {
    translations.payment_method = paymentMethod;
  }

  const userId = getTranslationIfAvailable(intl, 'app.support.disputes.table.user-id');
  if (userId) {
    translations.user_id = userId;
  }
  const userEmail = getTranslationIfAvailable(intl, 'app.support.disputes.table.user-email');
  if (userEmail) {
    translations.user_email = userEmail;
  }

  const countryCode = getTranslationIfAvailable(intl, 'app.support.disputes.table.country-code');
  if (countryCode) {
    translations.country_code = countryCode;
  }

  const amount = getTranslationIfAvailable(intl, 'app.support.disputes.table.amount');
  if (amount) {
    translations.transaction_amount_sum = amount;
  }
  const currency = getTranslationIfAvailable(intl, 'app.support.disputes.table.currency');
  if (currency) {
    translations.transaction_amount_currency = currency;
  }

  const fee = getTranslationIfAvailable(intl, 'app.support.disputes.table.fee');
  if (fee) {
    translations.dispute_fee_sum = fee;
  }

  const feeCurrency = getTranslationIfAvailable(intl, 'app.support.disputes.table.fee-currency');
  if (feeCurrency) {
    translations.dispute_fee_currency = feeCurrency;
  }

  const incomingDate = getTranslationIfAvailable(intl, 'app.support.disputes.table.incoming-date');
  if (incomingDate) {
    translations.dispute_incoming_date = incomingDate;
  }

  const reason = getTranslationIfAvailable(intl, 'app.support.disputes.table.reason');
  if (reason) {
    translations.dispute_reason = reason;
  }

  const type = getTranslationIfAvailable(intl, 'app.support.disputes.table.type');
  if (type) {
    translations.dispute_type = type;
  }

  const result = getTranslationIfAvailable(intl, 'app.support.disputes.table.result');
  if (result) {
    translations.dispute_result = result;
  }

  // Return null if no translations are available
  return Object.keys(translations).length > 0 ? translations : null;
};
